import { api } from "./client";

export interface Company {
  id: number;
  cnpj: string;
  razao_social: string | null;
  nome_fantasia: string | null;
  situacao_cadastral: string | null;
  uf: string | null;
  cnae_principal: string | null;
  natureza_juridica: string | null;
  endereco: string | null;
  porte: string | null;
  telefone: string | null;
  data_abertura: string | null;
  cnpj_data_json: string | null;
  score_overall: number | null;
  risk_level: string | null;
  monitoring_enabled: number;
  last_analysis_at: string | null;
  created_at: string;
}

export async function getCompanies(params?: { page?: number; limit?: number; search?: string; riskLevel?: string }) {
  const searchParams = new URLSearchParams();
  if (params?.page) searchParams.set("page", String(params.page));
  if (params?.limit) searchParams.set("limit", String(params.limit));
  if (params?.search) searchParams.set("search", params.search);
  if (params?.riskLevel) searchParams.set("riskLevel", params.riskLevel);
  return api.get("companies", { searchParams }).json<{ companies: Company[]; total: number; page: number; limit: number }>();
}

export async function getCompany(id: number) {
  return api.get(`companies/${id}`).json<{ company: Company; latestSnapshot: Record<string, unknown> | null; recentAlerts: unknown[] }>();
}

export async function addCompany(cnpj: string, tags?: string[], notes?: string) {
  return api.post("companies", { json: { cnpj, tags, notes } }).json<{ company: Company; analysisJob: { id: number } | null }>();
}

export async function deleteCompany(id: number) {
  return api.delete(`companies/${id}`).json();
}

export async function getCompanyHistory(id: number, limit = 30) {
  return api.get(`companies/${id}/history`, { searchParams: { limit: String(limit) } }).json<{ snapshots: Record<string, unknown>[] }>();
}
